import React, { useEffect, useState, useRef } from 'react';
import { useSetRecoilState } from 'recoil';

import { ADMIN_ACCESS_TOKEN_KEY, BASE_URL } from '../../App';
import { dialogContentsState } from '@components/templates';
import { logos } from '@assets/logos';
import {
  SupportBodyWrapper,
  SupportTable,
  ContactButtonWrapper,
  HeuronInfoWrapper,
  SupportLogoImg,
  SupportContacts,
} from './style';

const SupportPage = () => {
  const [supportType, setSupportType] = useState('');
  const [supportContent, setSupportContent] = useState('');
  const [accessToken, setAccessToken] = useState('');

  const setDialogContents = useSetRecoilState(dialogContentsState);
  const downloadRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    const newToken = localStorage.getItem(ADMIN_ACCESS_TOKEN_KEY);
    if (newToken) {
      setAccessToken(newToken);
    }
  }, []);

  const getDownloadPdf = (fileName: string, token: string) => {
    fetch(
      `${BASE_URL}/api/support/download?pdf=${fileName}&product=${window.__RUNTIME_CONFIG__.REACT_APP_PRODUCT_CODE}`,
      {
        method: 'GET',
        headers: {
          accept: '*/*',
          'Content-Type': 'application/pdf',
          Authorization: `Bearer ${token}`,
        },
      },
    )
      .then((response) => response.blob())
      .then((blob) => {
        const link = URL.createObjectURL(blob);
        if (downloadRef.current) {
          downloadRef.current.href = link;
          downloadRef.current.download = fileName + '.pdf';
          downloadRef.current.click();
        }
      });
  };
  return (
    <>
      <SupportBodyWrapper>
        <label>Support</label>
        <SupportTable>
          <tbody>
            <tr>
              <td>
                <h1>Need support? </h1>
                <h4>Request assistance Email or Phone and we&apos;ll connect you to an expert quickly.</h4>
                <ContactButtonWrapper>
                  <a href={'https://iheuron.com/ko.php/?act=cu'} target={'_blank'}>
                    Send Email
                  </a>
                </ContactButtonWrapper>
              </td>
              <td>
                <HeuronInfoWrapper>
                  <SupportLogoImg src={logos.heuron_logo_desc} alt={`Heuron Logo`} />
                  <SupportContacts>
                    <li className={`icon-ceo`}>
                      <strong>CEO</strong>
                      <span>&nbsp;: Donghoon Shin</span>
                    </li>
                    <li className={`icon-location`}>
                      <div>
                        <strong>Head Office</strong>
                        <span>
                          &nbsp;: 10F, C, 150, Yeongdeungpo-ro, Yeongdeungpo-gu, Seoul, 07292, Republic of Korea
                        </span>
                      </div>
                      <div>
                        <strong>US Office</strong>
                        <span>&nbsp;: 3003 North First Street #216, San Jose, CA 95134, US</span>
                      </div>
                    </li>
                    <li className={`icon-tel`}>
                      <strong>TEL</strong>
                      <span>&nbsp;: TEL : +82-2-2633-8595</span>
                    </li>
                    <li className={`icon-fax`}>
                      <strong>FAX</strong>
                      <span>&nbsp;: +82-2-2633-8596</span>
                    </li>
                    <li className={`icon-business`}>
                      <strong>Business license number</strong>
                      <span>&nbsp;: 728-86-00780</span>
                    </li>
                  </SupportContacts>
                </HeuronInfoWrapper>
              </td>
            </tr>
          </tbody>
        </SupportTable>
      </SupportBodyWrapper>
      <a ref={downloadRef} />
    </>
  );
};

export default SupportPage;
